import Mock from './mock';
export default async function getDealersPrice(variant) {
  return Mock.data.dealersPrice;
}
